/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_EstonianInputs */

const en_speechmatics_target_language_estonian = /** @type {(inputs: Speechmatics_Target_Language_EstonianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estonian`)
};

const fr_speechmatics_target_language_estonian = /** @type {(inputs: Speechmatics_Target_Language_EstonianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estonien`)
};

const de_speechmatics_target_language_estonian = /** @type {(inputs: Speechmatics_Target_Language_EstonianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`estnisch`)
};

const it_speechmatics_target_language_estonian = /** @type {(inputs: Speechmatics_Target_Language_EstonianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`estone`)
};

const ru_speechmatics_target_language_estonian = /** @type {(inputs: Speechmatics_Target_Language_EstonianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`эстонский`)
};

const es_speechmatics_target_language_estonian = /** @type {(inputs: Speechmatics_Target_Language_EstonianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`estonio`)
};

const zh_cn2_speechmatics_target_language_estonian = /** @type {(inputs: Speechmatics_Target_Language_EstonianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`爱沙尼亚语`)
};

const ja_speechmatics_target_language_estonian = /** @type {(inputs: Speechmatics_Target_Language_EstonianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エストニア語`)
};

const hi_speechmatics_target_language_estonian = /** @type {(inputs: Speechmatics_Target_Language_EstonianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एस्तोनियावासी`)
};

const pt_pt2_speechmatics_target_language_estonian = /** @type {(inputs: Speechmatics_Target_Language_EstonianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`estoniano`)
};

/**
* | output |
* | --- |
* | "Estonian" |
*
* @param {Speechmatics_Target_Language_EstonianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_estonian = /** @type {((inputs?: Speechmatics_Target_Language_EstonianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_EstonianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_estonian(inputs)
	if (locale === "de") return de_speechmatics_target_language_estonian(inputs)
	if (locale === "it") return it_speechmatics_target_language_estonian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_estonian(inputs)
	if (locale === "es") return es_speechmatics_target_language_estonian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_estonian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_estonian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_estonian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_estonian(inputs)
	return en_speechmatics_target_language_estonian(inputs)
});